//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';
import { createSelector } from 'reselect';

import {
  INSIGHTS_ROUTES,
  isGalleriesSubPageParams,
} from '@insights/insightsSidebarConstants';
import { ICuralateStore } from '@models/AppState';
import { isDefined } from '@utils/filterPredicates';

export const getCurrentInsightsPageRoute = createSelector(
  (state: ICuralateStore) => state.insights,
  (state: ICuralateStore) => state.insights.metadata.currentStateAndParams,
  (insightsRoot, currentStateAndParams) => {
    if (!currentStateAndParams) {
      return undefined;
    }
    return currentStateAndParams.state;
  },
);

const getCurrentInsightsPage = createSelector(
  (state: ICuralateStore) => state.insights,
  (state: ICuralateStore) => state.insights.metadata.currentStateAndParams,
  (insightsRoot, currentStateAndParams) => {
    if (!currentStateAndParams) {
      return undefined;
    }
    const { state, params } = currentStateAndParams;
    switch (state) {
      case INSIGHTS_ROUTES.GALLERIES:
        return insightsRoot.galleries.summary;
      case INSIGHTS_ROUTES.GALLERIES_DETAIL:
        if (!isDefined(params) || !isGalleriesSubPageParams(params)) {
          return insightsRoot.galleries.summary;
        }
        return PojoMap.get(insightsRoot.galleries.galleries, params.pageSource);
      case INSIGHTS_ROUTES.REVEAL:
        return insightsRoot.reveal;
      case INSIGHTS_ROUTES.SHOWROOM:
        return insightsRoot.showroom;
      case INSIGHTS_ROUTES.LIKE2BUY:
        return insightsRoot.like2buy;
      case INSIGHTS_ROUTES.LIKE2BUY_SUMMARY:
        return insightsRoot.like2BuySummary;
      case INSIGHTS_ROUTES.LIKE2BUY_V2:
        return insightsRoot.like2BuyV2;
      case INSIGHTS_ROUTES.SUMMARY:
      default:
        return insightsRoot.summary;
    }
  },
);

export default getCurrentInsightsPage;
